@if (course.retired) {
  <div class="course-retired-tag left">
    {{'retiredText'|translate:translations}}
  </div>
}
